import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import BarCodeReaderInput from './BarCodeReaderInput';
import ManualInput from './ManualInput';

export class BarCodeReader extends React.Component {
  state = {
    isManualInputUsed: false,
  };
  render() {
    const { isManualInputUsed } = this.state;
    return (
      <>
        <Typography
          variant="h5"
          gutterBottom
          align="center"
        >
          {this.props.children}
          <ManualInput
            onBlur={() => this.setState({ isManualInputUsed: false })}
            onFocus={() => this.setState({ isManualInputUsed: true })}
            onBarCodeRead={this.props.onBarCodeRead}
            label={this.props.manualInputLabel}
          />
        </Typography>
        {isManualInputUsed ? null : <BarCodeReaderInput onBarCodeRead={this.props.onBarCodeRead} />}
      </>
    )
  }
}

export const ScreensCenteredBarCodeReader = props => (
  <Grid
    container
    alignItems="center"      
    justify="center"          
    style={{flex: "1 0 auto"}}
  >
    <Grid item>
      <BarCodeReader {...props} />
    </Grid>
  </Grid>
);